/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { Box, Container } from '@bottlebooks/gatsby-theme-base';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { jsx } from 'theme-ui';
import SiteSearch from '../SiteSearch/SiteSearch';

export default function SiteSearchSection({
  locale,
  //   ...rest
}) {
  const { i18n } = useLingui();

  return (
    <Container>
      <Box
        sx={{
          transform: 'translateY(-50%)',
          position: 'relative',
          // Needs to go above other content, like a modal window. In particular the logos in the FeaturedExhibitors need to be overlaid.
          zIndex: 'modal',
        }}
      >
        <SiteSearch
          variant="largest"
          locale={locale}
          placeholder={i18n._(t`Search for producer, wine or region…`)}
        />
      </Box>
    </Container>
  );
}
